var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-examples-container"},[_c('TText',{attrs:{"text":"Examples","font_weight":"600","size":"24"}}),_c('div',{staticClass:"help-examples-inner-container"},[_c('TText',{attrs:{"text":"Here you can create examples."}}),_c('div',{staticClass:"help-examples-item-container"},[_c('div',{staticClass:"help-examples-item"},[_c('div',{staticClass:"help-examples-item-headline"},[_c('TText',{attrs:{"text":"Create Example Project","font_weight":"500","size":"18"}}),_c('div',{staticClass:"help-examples-item-headline-line"})],1),_c('TText',{attrs:{"text":"Creates an example project with an typical sequence and some pre-settings.","font_weight":"300"}}),_c('TText',{attrs:{"text":"Beware! This is a German Sequence! More are coming soon!","font_weight":"300"}}),_c('div',[_c('country-flag',{attrs:{"country":"de"}}),_c('ButtonOutlined',{attrs:{"text":"Create","width":"200","color":"green"},on:{"buttonClicked":function($event){_vm.createUObject({
            url: [
              {projects: ''},
              {'showWithEntitiesNormalized': ''}
            ],
            u_object: {
              name: 'Example Project',
              calendar_project_start: 'last monday'
            }
          }).then((id) => {
            _vm.joinProject({project_id: id}).then(() => {
              _vm.$router.push({
                name: 'ProjectTaktPlan',
                params: {
                  project_id: id,
                }
              });
              _vm.enterEditMode({project_id: id}).then(() => {
                _vm.createUObject({
              url: [
                {projects: id},
                {trains: 'completetrainsfromsequence'},
                {showWithEntitiesNormalized: ''}
              ],
              u_object: {
                sequence: 1,
                is_community: true,
                is_business: false,
                trains: [{
                    name: 'Innenausbau',
                    description: '',
                    train_start: 0,
                    workable_backlog: false,
                    // position: train_index + 1 + direction,
                    taktareas: [{
                      name: 'A',
                      description: '',
                      taktarea_start: 0,
                      square_meter: 0,
                    },
                    {
                      name: 'B',
                      description: '',
                      taktarea_start: 1,
                      square_meter: 0,
                    }]
                }]
              },
              trainsbacklogs: true,
            }).then(() => {
                _vm.$router.push({
                  name: 'ProjectTaktPlan',
                  params: {
                    project_id: id,
                  }
                });
              });  
              });
            });
          })}}})],1)],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }